import React from 'react';
import { Popover, Typography, List, ListItem, ListItemText, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { API } from '../../lib/api';
import dayjs from 'dayjs'; // Ensure you have dayjs installed for date formatting


const NotificationsComp = ({ anchorEl, handleClose, notifications, setNotifications }) => {

    const handleRemove = async (id) => {
        try {
            const response = await API.Notifications.Delete(id);
            
            if (response.status === 200) {
                setNotifications(prevNotifications => 
                    prevNotifications.filter(notification => notification._id !== id)
                );
            }
        } catch (error) {
            console.error('Error deleting notification:', error);
        }
    };



    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <Typography variant="h6" sx={{ p: 2 }}>Notifications</Typography>
            <List sx={{ maxHeight: 500, overflow: 'auto', padding: '12px' }}>
                {notifications.length > 0 ? (
                    notifications.map((notification, index) => (
                        <ListItem 
                            key={index}
                            sx={{
                                border: `1px solid #d4d9df`,
                                borderRadius: '8px',
                                margin: '12px 0', // Adds space between notifications
                                padding: '8px', // Adds padding inside the notification
                            }}
                        >
                            <ErrorOutlineIcon color='secondary' sx={{margin: '0.25em'}} />
                            {notification.hasLink ? (
                                <ListItemText
                                    primary={
                                    <>
                                        <a
                                        href={notification.hasLink}
                                        style={{ color: "#1976d2", textDecoration: "none" }} // tweak MUI theme color if needed
                                        >
                                        {notification.message}
                                        </a>
                                    </>
                                    }
                                    secondary={dayjs(notification.createdAt).format("MMMM D, YYYY [at] h:mm A")}
                                />
                                ) : (
                                <ListItemText
                                    primary={notification.message}
                                    secondary={dayjs(notification.createdAt).format("MMMM D, YYYY [at] h:mm A")}
                                />
                            )}                            
                            <Button color='error' sx={{margin: "0.25em"}} onClick={() => handleRemove(notification._id)}>Remove</Button>
                        </ListItem>
                    ))
                ) : (
                    <ListItem>
                        <ListItemText primary="No notifications" />
                    </ListItem>
                )}
            </List>
            <div style={{display: "flex", justifyContent: "center", margin: "1em"}}>
                <Button color='error' fullWidth>Clear All</Button>
            </div>
        </Popover>
    );
};

export default NotificationsComp;